import { itemsKeys } from '@character/apis/queries/character.queriesKeys';
import { useResetQuestStore } from '@devHubSingleQuest/store/hooks/useResetQuestStore';
import { newsKeys } from '@features/shared/news/apis/queries/news.queriesKeys';
import { useResetJournalQuestLogStore } from '@journalQuestLog/store/hooks/useResetDevhubStore';
import useRemoveAllWeb3Accounts from '@store/web3Store/hooks/useRemoveAllWeb3Accounts';
import { resetWalletProvidersLocalStorage } from '@store/web3Store/web3Store.functions';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { sendMessage } from 'react-message-event';
import { userKeys } from 'src/apis/queries/queriesKeys';
import { EUserContextMessagesKey } from '../userStore.enum';
import { defaultUserPersonalData } from '../userStore.variables';

export default function useLogout() {
	const queryClient = useQueryClient();
	const { removeAllWeb3Accounts } = useRemoveAllWeb3Accounts();

	const [, resetQuestStore] = useResetQuestStore();
	const [, resetJournalQuestLogStore] = useResetJournalQuestLogStore();

	const logout = useCallback(async () => {
		// invalidate ['skills'], needed for the logged out user, i.e: character journal
		queryClient.invalidateQueries(['skills']);
		// remove all relevant cache queries except for the ['user']
		queryClient.removeQueries({
			predicate: (query) => {
				const queriesToRemove = [
					'referenceItems',
					'whiteList',
					'userDeployedContract',
					itemsKeys.all[0],
					newsKeys.all[0],
					userKeys.statistics()
				];
				const userKey = userKeys.all[0];
				return (
					(query.queryKey[0] === userKey && query.queryKey.length > 1) ||
					queriesToRemove.includes(query.queryKey[0] as string)
				);
			}
		});
		// reset ['user] to the defaultUserPersonalData
		queryClient.setQueryData(userKeys.all, defaultUserPersonalData);

		sendMessage({ key: EUserContextMessagesKey.logout });

		removeAllWeb3Accounts();

		resetQuestStore();
		resetJournalQuestLogStore();

		// wallet connect
		resetWalletProvidersLocalStorage();
	}, [queryClient, removeAllWeb3Accounts, resetJournalQuestLogStore, resetQuestStore]);

	return { logout };
}
